import { DIRECTION_LEFT, DIRECTION_RIGHT, DIRECTION_UP, DIRECTION_DOWN, CHILDREN_ENDPOINT_ACTION, CHILDREN_ENDPOINT_ACTION_RESULT, } from '../contants';
/**
 * 컴포넌트 children 의 endPoint Action 을 체크한다.
 * 탐색된 노드가 없는 경우 해당 endPoint Action 에 따라 다음 동작을 수행시킨다, (loop 할지, isolated 할지, 다음 focusable container 를 탐색할지
 */
var checkChildrenEndpointAction = function (direction, childrenEndpointAction) {
    switch (childrenEndpointAction) {
        case CHILDREN_ENDPOINT_ACTION.ISOLATED:
            return CHILDREN_ENDPOINT_ACTION_RESULT.ISOLATED;
        case CHILDREN_ENDPOINT_ACTION.LOOP_VERTICAL:
            if (direction === DIRECTION_UP || direction === DIRECTION_DOWN)
                return CHILDREN_ENDPOINT_ACTION_RESULT.LOOP;
            break;
        case CHILDREN_ENDPOINT_ACTION.LOOP_HORIZON:
            if (direction === DIRECTION_LEFT || direction === DIRECTION_RIGHT)
                return CHILDREN_ENDPOINT_ACTION_RESULT.LOOP;
            break;
        case CHILDREN_ENDPOINT_ACTION.LOOP_UP:
            if (direction === DIRECTION_UP)
                return CHILDREN_ENDPOINT_ACTION_RESULT.LOOP;
            break;
        case CHILDREN_ENDPOINT_ACTION.LOOP_DOWN:
            if (direction === DIRECTION_DOWN)
                return CHILDREN_ENDPOINT_ACTION_RESULT.LOOP;
            break;
        case CHILDREN_ENDPOINT_ACTION.LOOP_LEFT:
            if (direction === DIRECTION_LEFT)
                return CHILDREN_ENDPOINT_ACTION_RESULT.LOOP;
            break;
        case CHILDREN_ENDPOINT_ACTION.LOOP_RIGHT:
            if (direction === DIRECTION_RIGHT)
                return CHILDREN_ENDPOINT_ACTION_RESULT.LOOP;
            break;
        case CHILDREN_ENDPOINT_ACTION.LOOP_ALL:
            return CHILDREN_ENDPOINT_ACTION_RESULT.LOOP;
        default:
            break;
    }
    return CHILDREN_ENDPOINT_ACTION_RESULT.NONE;
};
export default checkChildrenEndpointAction;
